export class Conversations {
    public id: number;
    public assigned_to: number;
    public assigned_by: number;
    public title: string;
    public created_at: string;
    public updated_at: string;
}
